const endpoints = {
  getUnits: 'api/v2/units/',
}

export default endpoints
